import { useEffect, useState } from 'react';
import Config from '../config/config';
import ApiUrls from '../constants/ApiUrls';

export type MaintenanceDuration = {
  start: string; // 01/31/2025 12:55
  end: string; // 01/31/2025 12:55
};

interface APIResponse {
  data: {
    maintenanceMode: boolean;
    duration: MaintenanceDuration;
  };
}

const isAPIResponse = (obj: any) => {
  return (
    obj.hasOwnProperty('data') &&
    obj.data.hasOwnProperty('maintenanceMode') &&
    typeof obj.data.maintenanceMode === 'boolean'
  );
};

export const useMaintenanceMode = (endpoint: string) => {
  const [isInMaintenanceMode, setIsInMaintenanceMode] = useState(false);
  const [isFetchingStatus, setIsFetchingStatus] = useState(true);
  const [maintenanceDuration, setMaintenanceDuration] = useState<null | MaintenanceDuration>(null);

  const checkMaintenanceMode = () => {
    fetch(`${Config.api.baseUrl}${ApiUrls.MAINTENANCE_MODE}/${endpoint}`)
      .then((response) => {
        response
          .json()
          .then((parsedResponseBody: APIResponse) => {
            if (isAPIResponse(parsedResponseBody)) {
              const { maintenanceMode, duration } = parsedResponseBody.data;
              setIsInMaintenanceMode(maintenanceMode);
              if (duration) setMaintenanceDuration(duration);
            } else {
              setIsInMaintenanceMode(false);
            }
          })
          .catch((e) => {
            console.log(e);
            setIsInMaintenanceMode(false);
          });
      })
      .catch((e) => {
        console.log(e);
        setIsInMaintenanceMode(false);
      })
      .finally(() => {
        setIsFetchingStatus(false);
      });
  };

  useEffect(() => {
    checkMaintenanceMode();
  }, []);

  return {
    isInMaintenanceMode,
    isFetchingStatus,
    maintenanceDuration,
  };
};
